import { render } from "./AddCompanyAdminModal.vue?vue&type=template&id=b7f26116&ts=true"
import script from "./AddCompanyAdminModal.vue?vue&type=script&lang=ts"
export * from "./AddCompanyAdminModal.vue?vue&type=script&lang=ts"

import "./AddCompanyAdminModal.vue?vue&type=style&index=0&id=b7f26116&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__